
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_roles/[role]/[customquery]/[[...path]]",
      function () {
        return require("private-next-pages/_roles/[role]/[customquery]/[[...path]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_roles/[role]/[customquery]/[[...path]]"])
      });
    }
  